import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ConfigService,
  EntityParams,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import { ICondicaoPagamento } from '../models/condicao.model';

@Injectable()
export class CondicaoService extends EntityService<ICondicaoPagamento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'condicao_pagamento'
    });
  }

  /**
   * Retorna as condições de pagamentos disponíveis para um catlaogo
   * @param params
   * @param domainId
   * @param require_pagination
   * @returns
   */
  condicoesCatalogo(
    params: string | EntityParams<ICondicaoPagamento>,
    domainId?: string,
    require_pagination = false
  ): Observable<ICondicaoPagamento | IEntityPagination<ICondicaoPagamento[]>> {
    let paramsAux: string = null;
    let paramsHttp = new HttpParams();

    if (typeof params === 'string') {
      paramsAux = `?${params}${
        require_pagination ? '&require_pagination=true' : ''
      }`;
      if (domainId) paramsAux += `&domain_id=${domainId}`;
    } else {
      if (params.where) paramsHttp = this.getParams(params.where);
      if (domainId) paramsHttp = paramsHttp.set('domain_id', domainId);
      if (require_pagination) {
        paramsHttp = paramsHttp.set('require_pagination', require_pagination);
      }
      if (params.pagination) {
        paramsHttp = paramsHttp.set('page', params.pagination.page);
        paramsHttp = paramsHttp.set('page_size', params.pagination.page_size);
      }
      if (params.include && params.include.length)
        paramsHttp = paramsHttp.set('include', params.include.join(','));
      if (params.order_by && params.order_by.length)
        paramsHttp = paramsHttp.set('order_by', params.order_by.join(','));
      if (params.list_options)
        paramsHttp = paramsHttp.set('list_options', params.list_options);
      paramsAux = null;
    }

    const url = this.baseURL + '/catalogo' + (paramsAux || '');

    return this.http
      .get<any>(url, {
        headers: this.getHeader(),
        params: paramsHttp
      })
      .pipe(
        map(data => {
          if (require_pagination) {
            data = data as IEntityPagination<ICondicaoPagamento>;
            return {
              data: data[this.entitiesName],
              pagination: data.pagination
            };
          }
          data = data as ICondicaoPagamento[];
          return data[this.entitiesName];
        }),
        catchError(this.handleError)
      );
  }
}
